import { useEffect, useRef } from "react";

/**
 * HelpScoutBeacon - Loads Help Scout Beacon widget for support chat/email.
 * 
 * Controlled by REACT_APP_ENABLE_HELPSCOUT_BEACON environment variable.
 * - Set to "true" to enable
 * - Set to "false" or omit to disable
 * 
 * Rollback: Set env var to "false" or remove <HelpScoutBeacon /> from AppLayout.
 */
export default function HelpScoutBeacon() {
  const loadedRef = useRef(false);
  
  useEffect(() => {
    // Check environment flag
    const isEnabled = process.env.REACT_APP_ENABLE_HELPSCOUT_BEACON === "true";
    
    if (!isEnabled) {
      return;
    }
    
    // Prevent duplicate loading
    if (loadedRef.current) {
      return;
    }
    
    // Check if Beacon is already initialized
    if (window.Beacon && window.Beacon.readyQueue !== undefined) {
      return;
    }
    
    loadedRef.current = true;
    
    // Inject Help Scout Beacon snippet exactly as provided
    // DO NOT modify this script block
    !function(e,t,n){function a(){var e=t.getElementsByTagName("script")[0],n=t.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://beacon-v2.helpscout.net",e.parentNode.insertBefore(n,e)}if(e.Beacon=n=function(t,n,a){e.Beacon.readyQueue.push({method:t,options:n,data:a})},n.readyQueue=[], "complete"===t.readyState)return a();e.attachEvent?e.attachEvent("onload",a):e.addEventListener("load",a,!1)}(window,document,window.Beacon||function(){});
    
    // Initialize Beacon with the provided ID
    window.Beacon('init', 'e20092ca-0f37-4257-91d5-c0c45208d9ce');
    
  }, []);
  
  // This component renders nothing - it only loads the script
  return null;
}
